var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginEmbelishment1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 461.762,
    height: 702.037,
    viewBox: "0 0 461.762 702.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xku19n119a",
    x1: 0.449,
    y1: -0.062,
    x2: 0.531,
    y2: 0.837,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7eaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Background embelishment_1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 55",
    d: "M0 0h246.385l200.362 214.651a55.757 55.757 0 0 1-2.735 78.86L17.282 691.053A55.7 55.7 0 0 1 0 702.037z",
    style: {
      fill: "url(#xku19n119a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 58",
    d: "m0 0 126.559 135.582a41.472 41.472 0 0 1-2.039 58.656L0 310.243z",
    transform: "translate(0 79.785)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmbelishment1);
export default __webpack_public_path__ + "static/media/login-embelishment-1.bdb7296ad5717db37f52afae3fe448ef.svg";
export { ForwardRef as ReactComponent };